import React from "react";
import { LeftPanel } from "../leftNav/leftPanel.jsx";

export default class SplashPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRedirecting: false,
            userContext: undefined,
            eventClassifiers: [],
            widgetsInView: [],
            visibleMarketIds: [],
            selectedPrices: [],
            oddsLadder: undefined,
            prices: [],
            isEventCard: undefined,
            isAnchorPage: false,
            eventCardEventClassifier: {},
            breadCrumbs: [],
            leftNavEventClassifier: undefined,
            subscribedTaggedValuesIds: [],
            multiMarketsWidgetAllowedOn: [100014, 100017, 100016, 100032, 5793124],
            sportRadarId: undefined,
            leftPanelToggled: false,
            rightPanelToggled: false,
            betSlipMinimised: false,
            virtualTabs: [],
            showLoginWidget: false,
            modalConfig: {
                show: false,
                extraClass: " big",
                config: {},
                content: {},
                modalDialogClass: ""
            },
            eventNotFound: this.props.notfound,
            orders: [] //orderCache Orders
        };


    }

    //from popular links
    handleLinkSelected(params) {
        var homePageType = params.homePageType ? params.homePageType : "InPlay";
        const key = params.key ? params.key : params.homePageType;
        switch (key) {
            case "inplay": homePageType = "InPlay"; break;
            case "home": homePageType = "Exch"; break;
        }

        this.loadHomePage(null, homePageType);
    }

    render() {
        const mode = configurationSettings.mode.charAt(0).toUpperCase() + configurationSettings.mode.slice(1);
        const whiteLabel = configurationSettings.whiteLabel.replace("Betdaq", "BETDAQ");
        const popularLinksKey = String.format("gEP.{0}-{1}-Web.PopularLinks", mode, whiteLabel);
        const iframeStyle = { "width": "100%", "height": "100%", "minHeight": "1000px", "border": "none", "zIndex": -1 };

        if (configurationSettings.mode === "gameday") {
            iframeStyle.zIndex = "auto";
        }

        return (
            <div style={{ "minHeight": "500px" }}>
                <div id="leftPanel" className="d-lg-none">
                    <LeftPanel config={GBEglobal.settings[popularLinksKey]}
                        controller={this.props.controller}
                        modes={this.props.modes}
                        onLinkSelected={this.handleLinkSelected.bind(this)}
                        isBlockedFromGames={this.props.isBlockedFromGames}
                        history={this.props.history}
                    />
                </div>
                <div className="row" style={{ "margin": 0, "transition": "margin 0.25s ease- out" }}>
                    <iframe data-hj-allow-iframe="" style={iframeStyle} src={this.props.config.path}></iframe>
                </div>
            </div>
        );
    }
}

export { SplashPage };